import axios from "axios";

export const OpenAiApiConfig = async (type) => {
  const token = process.env.REACT_APP_OPEN_AI_KEY;
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
};

export const postOpenAiApi = async (url, apiData) => {
  return axios.post(`${url}`, apiData, await OpenAiApiConfig());
};
